// DEMO / PLACEHOLDER leadership profiles — these names are demo content for
// layout purposes only and do NOT represent actual DtOrbit employees.
// Replace name, photo, bio, expertise and linkedin with official team details
// when available. Set `photo` to an image URL and `placeholder` to false once
// verified information is provided.

export const LEADERS = [
    {
        id: 1,
        placeholder: true,
        name: "Aarav Mehta",
        role: "Founder & CEO",
        photo: "/assets/leadership/aarav-mehta.webp",
        bio: "Sets DtOrbit's vision and strategy, leading the platform's growth across digital finance and exchange technology.",
        expertise: ["Strategy", "Digital Finance", "Leadership"],
        linkedin: null,
    },
    {
        id: 2,
        placeholder: true,
        name: "Farhan Khan",
        role: "Chief Operating Officer",
        photo: "/assets/leadership/farhan-khan.webp",
        bio: "Drives day-to-day operations and execution, keeping exchange processing smooth, dependable and well-organized.",
        expertise: ["Operations", "Strategy", "Execution"],
        linkedin: null,
    },
    {
        id: 3,
        placeholder: true,
        name: "Arjun Malhotra",
        role: "Chief Technology Officer",
        photo: "/assets/leadership/arjun-malhotra.webp",
        bio: "Owns the technology vision — platform architecture, live rate infrastructure and secure transaction processing.",
        expertise: ["Technology", "Blockchain", "Infrastructure"],
        linkedin: null,
    },
    {
        id: 4,
        placeholder: true,
        name: "Ayaan Siddiqui",
        role: "Head of Product",
        photo: "/assets/leadership/ayaan-siddiqui.webp",
        bio: "Shapes the exchange experience, making every step from live rate to INR payout simple and intuitive.",
        expertise: ["Product", "Fintech", "User Experience"],
        linkedin: null,
    },
    {
        id: 5,
        placeholder: true,
        name: "Rehan Ahmed",
        role: "Head of Growth",
        photo: "/assets/leadership/rehan-ahmed.webp",
        bio: "Leads growth initiatives, partnerships and business development across digital finance markets.",
        expertise: ["Growth", "Business Development", "Marketing"],
        linkedin: null,
    },
    {
        id: 6,
        placeholder: true,
        name: "Neha Kapoor",
        role: "Head of Operations",
        photo: "/assets/leadership/neha-kapoor.webp",
        bio: "Runs exchange operations and verification workflows with a focus on reliability and user support.",
        expertise: ["Operations", "Process", "Support"],
        linkedin: null,
    },
];
